export const TestimonialStatusEnum = Object.freeze({
    processing: "processing",
    active: "active",
    review: "review",
    archived: "archived",
});
